import { render } from "./modOrderRecord.vue?vue&type=template&id=12c47180&scoped=true"
import script from "./modOrderRecord.vue?vue&type=script&lang=js"
export * from "./modOrderRecord.vue?vue&type=script&lang=js"

import "./modOrderRecord.vue?vue&type=style&index=0&id=12c47180&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c47180"]])

export default __exports__